import React from 'react'
// import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom';

import { SideBarItem } from '../../../../components';
import { baseUrl } from '../../../../config/baseUrl';

const listSideBarItem = [
  {
    id: 1,
    title: 'Introduction',
    path: '/apis/intro',
    children: [
      {
        id: 11,
        title: 'API Introduction',
        path: `${baseUrl}apis/intro`
      },
      {
        id: 12,
        title: 'API Authentication',
        path: `${baseUrl}apis/intro/auth`
      },
      {
        id: 13,
        title: 'Making Requests',
        path: `${baseUrl}apis/intro/making-requests`
      },
      {
        id: 14,
        title: 'Response Definition',
        path: `${baseUrl}apis/intro/response-definition`
      },
    ]
  },
  {
    id: 2,
    title: 'Authentication',
    path: '/apis/user-auth',
    children: [
      {
        id: 21,
        title: 'User Register',
        path: `${baseUrl}apis/user-auth/register`,
      },
      {
        id: 22,
        title: 'User Login',
        path: `${baseUrl}apis/user-auth/login`,
      }
    ]
  },
  {
    id: 3,
    title: 'Map',
    path: '/apis/map',
    children: [
      {
        id: 31,
        title: 'Find near segments',
        path: `${baseUrl}apis/map/find-near-segments`,
      },
      {
        id: 32,
        title: 'Direct',
        path: `${baseUrl}apis/map/direct`,
      }
    ]
  },
  {
    id: 4,
    title: 'Traffic Status',
    path: '/apis/status',
    children: [
      {
        id: 41,
        title: 'Get Traffic Status',
        path: `${baseUrl}apis/status/get-traffic-status`,
      },
      {
        id: 42,
        title: 'Report',
        path: `${baseUrl}apis/status/report`
      }
    ]
  },
  {
    id: 5,
    title: 'References',
    path: `${baseUrl}apis/references`
  },
  {
    id: 6,
    title: 'Notification',
    path: `${baseUrl}apis/notification`
  },
  {
    id: 7,
    title: 'Distance',
    path: `${baseUrl}apis/distance`
  },
  {
    id: 8,
    title: 'Application',
    path: `${baseUrl}apis/application`
  },
  {
    id: 9,
    title: 'Feedback',
    path: `${baseUrl}apis/feedback`
  }
]

const ApisSideBar = props => {
  const location = useLocation();
  const { pathname } = location;

  return (
    <div>
      {
        listSideBarItem.map((sideBarItem) => {
          if (sideBarItem.children) {
            return (
              <SideBarItem isActive={pathname.includes(sideBarItem.path)} key={sideBarItem.id} title={sideBarItem.title}>
                {
                  sideBarItem.children.map((child) => (
                    <SideBarItem isActive={pathname === child.path} key={child.id} title={child.title} path={child.path}/>
                  ))
                }
              </SideBarItem>
            )
          }
          return (
            <SideBarItem path={sideBarItem.path} isActive={pathname.includes(sideBarItem.path)} key={sideBarItem.id} title={sideBarItem.title} />
          )
        })
      }
    </div>
  )
}

ApisSideBar.propTypes = {

}

export default ApisSideBar
